import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { Provider } from 'react-redux';
import App from './components/App';
import { store } from './redux/store';
import * as serviceWorker from './serviceWorker';
import './assets/styles/index.scss';
import { setupAxios } from './api/axios';

setupAxios();

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <GoogleReCaptchaProvider language='en' reCaptchaKey="6LdwWlAfAAAAAIiQU4bJowPnyeEHSzp_nZORiSK3">
        <Provider store={store}>
          <App />
        </Provider>
      </GoogleReCaptchaProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
